import request from '@/utils/request'
import qs from 'qs'
export function getListMoneybyInvoiceReport(query) {
  return request({
    url: '/report-service/v1/invoice-report/payment-invoice',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
export function getListMoneybyInvoiceReportExcel(query) {
  return request({
    url: '/report-service/v1/invoice-report/payment-invoice/excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    },
    responseType: 'blob'
  })
}
export function getAllFO() {
  return request({
    url: '/config-service/v1/account',
    method: 'get',
    params: {
      department: 'FO'
    }
  })
}

// common api for filter
export function getAgentListForReport() {
  return request({
    url: '/config-service/v1/agent/simple-list',
    method: 'get'
  })
}
